import { Dienststelle } from '../module/dienststelle';
import { ChangeDetectorRef, Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import {
  BikeCategory,
  BikeCategoryExtendedOptions,
} from '../module/BikeCategory';

@Injectable({
  providedIn: 'root',
})
export class DataSharingService {
  anzahlKinder = 0;
  bikeCategory: BikeCategory | number = 0;
  constructor() {
    this.selectedDate = new Date();
    // Removed localStorage saving - users must enter code every time
    // const ds = localStorage.getItem('DsCode');
    // if (ds) {
    //   this.dsCode = ds;
    //   this.bikeCategory = this.isVivantes() ? BikeCategory.OTHER : 0;
    // }
  }
  public ldList = [
    { value: 24, display: '24 Monate' },
    { value: 30, display: '30 Monate' },
    { value: 36, display: '36 Monate' },
    { value: 48, display: '48 Monate' },
  ];

  public dienststelle: Dienststelle;
  public dsCode = '';
  public currInfo = '';
  public bArt = 1;
  public stKlasse = 1;
  public pkvValue = 0;
  public kaufpreis = 3500;
  public bruttoKaufUVP = 3500;
  public bruttoKaufUVPTouched = false;
  public modusErweitert = false;
  public bruttogehalt = 3000;
  public kinderValue = 0;
  public kircheValue = true;
  public radFahrSchutz = true;
  public olderThan23 = false;
  public pvAnteil = 0;
  public leasingDuration = 36;

  // TODO rename or optimize
  public rvValue = true;
  public kvValue = 'gkv';
  public rsValue = 14.6;
  public zusatzValue = 2.5;
  public selectedDate: Date;
  public showFairbetrag = true;
  public inspectionDisabled = false;
  public zuschussModellPercent = 0;
  public showRequiredErrors = false;
  public kaufpreisTouched = false;
  public bruttogehaltTouched = false;

  public limbachModel: 'traditionell' | 'niedrigeRate' | 'maximaleErsparnis' | null = null;
  public limbachDialogAcknowledged: Set<string> = new Set<string>();
  public readonly limbachModelOptions: {
    value: 'traditionell' | 'niedrigeRate' | 'maximaleErsparnis';
    display: string;
    leasingfaktor: number;
    uebernahmeprozent: number;
    restwert: number;
  }[] = [
    { value: 'traditionell', display: 'Traditionell', leasingfaktor: 0.033, uebernahmeprozent: 0.18, restwert: 0.10 },
    { value: 'niedrigeRate', display: 'Niedrige Rate', leasingfaktor: 0.031, uebernahmeprozent: 0.25, restwert: 0.15 },
    { value: 'maximaleErsparnis', display: 'Maximale Ersparnis', leasingfaktor: 0.0381, uebernahmeprozent: 0.05, restwert: 0.05 },
  ];

  private readonly limbachStadtCodes = ['lio-0526', 'lnr-0526', 'lme-0526'];
  private readonly limbachBaederCodes = ['blo-0526', 'bnr-0526', 'bme-0526'];

  public isLimbachLeasing(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return (
      this.limbachStadtCodes.includes(code) ||
      this.limbachBaederCodes.includes(code)
    );
  }

  public getLimbachGroup(): 'stadt' | 'baeder' | null {
    const code = (this.dsCode || '').trim().toLowerCase();
    if (this.limbachStadtCodes.includes(code)) { return 'stadt'; }
    if (this.limbachBaederCodes.includes(code)) { return 'baeder'; }
    return null;
  }

  public getLimbachModelByCode(code: string): 'traditionell' | 'niedrigeRate' | 'maximaleErsparnis' | null {
    const lower = (code || '').trim().toLowerCase();
    if (lower === 'lio-0526' || lower === 'blo-0526') { return 'traditionell'; }
    if (lower === 'lnr-0526' || lower === 'bnr-0526') { return 'niedrigeRate'; }
    if (lower === 'lme-0526' || lower === 'bme-0526') { return 'maximaleErsparnis'; }
    return null;
  }

  public getLimbachConfig() {
    if (!this.limbachModel) { return null; }
    return this.limbachModelOptions.find((opt) => opt.value === this.limbachModel) || null;
  }

  public isLimbachAcknowledged(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return this.limbachDialogAcknowledged.has(code);
  }

  dataSubject = new BehaviorSubject<string>(''); // Initialize with an empty string or any default value
  data$ = this.dataSubject.asObservable();
  inputChanged = new BehaviorSubject<any>(true); // Initialize with an empty string or any default value
  changes$ = this.inputChanged.asObservable();
  toggleInfo(infoType: string): void {
    this.currInfo = this.currInfo === infoType ? '' : infoType;
  }
  get useNetBikePrice(): boolean {
    const affectedServices = [
      'Mie-2023',
      'Din-2023',
      'Sta-2023',
      'Eic-2023',
      'Hro-2022',
      'Gar-2023',
      'Met-2023',
      'Wdn-2023',
      'Swa-2023',
      'Ein-2023',
      'Bre-2023',
      'Oyt-2023',
      'Dül-2023',
      'Lud-2023',
    ];
    return affectedServices.includes(this.dsCode);
  }

  update(newData: string) {
    this.dsCode = newData.trim();
    // Removed localStorage saving - users must enter code every time
    // if (this.dsCode !== '') {
    //   localStorage.setItem('DsCode', this.dsCode);
    // }
    this.dataSubject.next(this.dsCode);
  }

  updateDienststelle(ds: Dienststelle): void {
    // TODO add in new structure
    this.dienststelle = ds;
    if (this.dsCode.includes('-5')) {
      // Arbeitnehmer als standard
      this.bArt = 2;
    }
    this.ldList = [];
    // TODO Check if the  this.dienststelle.leasingDuration is set correctly
    const ld = this.dienststelle.leasingDuration.split(';');
    this.ldList = ld.map((erg) => {
      return { value: Number(erg), display: erg + ' Monate' };
    });

    this.leasingDuration = this.getMaxLeasingDauer(ld);
    this.bikeCategory = this.isVivantes() ? BikeCategory.OTHER : 0;
  }

  showDiv(divVal: string): void {
    if (this.currInfo !== divVal) {
      this.currInfo = divVal;
    } else {
      this.currInfo = '';
    }
  }

  public isVivantes(): boolean {
    return this.dsCode.startsWith('Viv-');
  }

  public isRuhrverbandDienststelle(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return ['ruk-0326', 'ruh-0526', 'rwr-0526', 'lul-0526'].includes(code);
  }

  public getMaxPreis(): number {
    if (this.isRuhrverbandDienststelle()) {
      switch (this.leasingDuration) {
        case 24:
          return 6228;
        case 30:
          return 6060;
        case 36:
          return 5901;
      }
    }
    // Lucky Bike (Lbi-5110): 48 Monate hat eine eigene Preisgrenze,
    // 36 Monate kommt weiterhin aus dem maxPreis-Feld in Firebase.
    if (this.isLuckyBikeDienststelle() && this.leasingDuration === 48) {
      return 5775;
    }
    return this.dienststelle?.maxPreis;
  }

  public isLneDienststelle(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return code === 'lne-0626';
  }

  public isLuckyBikeDienststelle(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return code === 'lbi-5110';
  }

 
  public isOneProzentUStArbeitgeber(): boolean {
    return this.isLuckyBikeDienststelle();
  }

  public isNipDienststelle(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return code === 'nip-0526';
  }

  public isEerDienststelle(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return code === 'b-eer-5247';
  }

  public isDienststelleLocked(): boolean {
    const code = (this.dsCode ?? '').trim().toLowerCase();
    if (!code) {
      return false;
    }
    const unlockedCodes = [
      'freiberuflich-5555',
      'business-5555',
      'kein dienststellencode',
      'dienststellencode',
      'kal-radimdienst',
      'kalradimdienst',
    ];
    return !unlockedCodes.includes(code);
  }

  public isFreiberufler(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return (
      code.startsWith('freiberuflich-') || this.dienststelle?.customerType === 1
    );
  }

  // Codes mit Präfix "B-" sind immer Freiberufler oder Business, nie Standard:
  // customerType === 1 macht sie zu Freiberuflern, alles andere zu Business.
  public isBusiness(): boolean {
    const code = (this.dsCode || '').trim().toLowerCase();
    return (
      code.startsWith('business-') ||
      code.startsWith('b-') ||
      this.dienststelle?.customerType === 2
    );
  }

  public getKaufpreis(): number {
    if (this.useNetBikePrice) {
      return this.kaufpreis / 1.19;
    }
    return this.kaufpreis;
  }

  private getMaxLeasingDauer(ld: string[]): number {
    const numberArray = ld
      .map((str) => Number(str))
      .filter((num) => !isNaN(num));
    // Find the maximum number in the array
    return Math.max(...numberArray);
  }
}
